// extracted by mini-css-extract-plugin
export default {"modal-change-info-user":"modalInfoUser_modal-change-info-user__lqiKd"};